module.exports = __webpack_public_path__ + "img/shezhen.df04c951.png";